import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", _mergeProps({
    class: ["icon", [_ctx.icon]],
    style: {}
  }, _ctx.$attrs), null, 16))
}